/**
 * Read marketing-attribution context out of the current page:
 *   - UTM params from query string
 *   - document.referrer
 *   - navigator.userAgent
 *
 * Persists UTMs to sessionStorage so a visitor who clicks an ad, then navigates
 * around the site, still has them on submit.
 */
const SS_KEY = "mostash_utm";

function readUtmsFromUrl() {
  if (typeof window === "undefined") return {};
  try {
    const params = new URLSearchParams(window.location.search);
    const out = {};
    for (const key of ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"]) {
      const v = params.get(key);
      if (v) out[key] = v.slice(0, 160);
    }
    return out;
  } catch {
    return {};
  }
}

export function captureAttribution() {
  const fromUrl = readUtmsFromUrl();
  if (Object.keys(fromUrl).length > 0) {
    try { window.sessionStorage.setItem(SS_KEY, JSON.stringify(fromUrl)); } catch { /* ignore */ }
    return fromUrl;
  }
  try {
    const cached = window.sessionStorage.getItem(SS_KEY);
    if (cached) return JSON.parse(cached);
  } catch { /* ignore */ }
  return {};
}

export function getAttributionPayload() {
  const utms = captureAttribution();
  const referrer = typeof document !== "undefined" ? (document.referrer || null) : null;
  const device_info = typeof navigator !== "undefined" ? (navigator.userAgent || null) : null;
  return { ...utms, referrer, device_info };
}
